// AdminLayout.js (Corrected version)
import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useVendorAuth } from '../../context/VendorAuthContext';

import { Provider } from "react-redux"; // Redux Provider
import adminStore from "../redux/store";

import Header from '../layout/Header'; // Admin Header
import Sidebar from '../layout/Sidebar'; // Admin Sidebar
import Footer from '../layout/Footer'; // Admin Footer
import './vendor-dashboard-responsive.css';

const AdminLayout = () => {
  const { vendor } = useVendorAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const registrationStep = Number(vendor?.last_registration_step ?? 0);

  // Navigation guard: redirect based on registration progress
  useEffect(() => {
    if (!vendor) return;
    if (vendor.is_impersonated) return; // Superadmin accessing vendor profile: bypass registration/KYC guards

    const currentPath = location.pathname;

    // Steps: 1-2 signup, 3-5 KYC verification, 6-11 profile setup, 12+ vendor portal
    if (registrationStep < 6) {
      // KYC not done yet — force to kyc-verification
      if (!currentPath.includes('/kyc-verification')) {
        navigate('/admin/kyc-verification', { replace: true });
      }
    } else if (registrationStep >= 6 && registrationStep < 12) {
      // KYC done, profile setup not done — force to profile-setup
      if (!currentPath.includes('/profile-setup')) {
        navigate('/admin/profile-setup', { replace: true });
      }
    }
    // registrationStep >= 12 — portal access, no forced redirect
  }, [vendor, registrationStep, navigate, location.pathname]);

  // Theme and layout attributes for the admin panel
  useEffect(() => {
    const html = document.documentElement;
    document.body.classList.add('vendor-admin-active');

    // Set Velzon theme attributes on <html>
    html.setAttribute('data-layout', 'vertical');
    html.setAttribute('data-topbar', 'light');
    html.setAttribute('data-sidebar', 'dark');
    html.setAttribute('data-layout-style', 'default');
    html.setAttribute('data-layout-position', 'fixed');
    html.setAttribute('data-layout-width', 'fluid');

    // Preserve existing sidebar size or set default
    if (!html.getAttribute('data-sidebar-size')) {
      html.setAttribute('data-sidebar-size', 'lg');
    }

    // Feather icons replacement (if library is loaded)
    if (window.feather) {
      window.feather.replace();
    }

    // Dynamically ensure a favicon exists
    let favicon = document.querySelector('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = '/mangoloops-fevicon.png';

    // Cleanup when leaving the admin area
    return () => {
      html.removeAttribute('data-layout');
      html.removeAttribute('data-sidebar-size');
      html.removeAttribute('data-topbar');
      html.removeAttribute('data-sidebar');
      html.removeAttribute('data-layout-style');
      html.removeAttribute('data-layout-position');
      html.removeAttribute('data-layout-width');
      document.body.classList.remove('vendor-admin-active');
      document.body.classList.remove('vertical-sidebar-enable');
    };
  }, []);

  return (
    <Provider store={adminStore}>
      <div id="layout-wrapper" className="vendor-admin-shell">
        <Header />
        <Sidebar />
        <div className="vertical-overlay" onClick={() => document.body.classList.remove('vertical-sidebar-enable')}></div>
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <Outlet />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </Provider>
  );
};

export default AdminLayout;
